module.exports = __webpack_public_path__ + "img/illu_api.bdee2a4e.svg";